import React, { Component, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import { get } from 'lodash';
import { ReactReduxContext } from 'react-redux';
import safelyHoistStatics from '../../helpers/safelyHoistStatics';
import NotFound from '../Common/NotFound';
import { isFeatureEnabled } from '../../stores/features';

const checkEnabled = (params, store) => {
  const routeType = get(params, 'route.meta.routeType');

  return !isFeatureEnabled(
    store.getState().features,
    `disable_jp_web_route_${routeType}`,
    'on'
  );
};

/**
 * Allows for a route to 404 and behave as though it's disabled.
 * Note: This should be used for A/B tests and canary releases.
 * As it's to be used to show JP Main / JP Web pages we should not link to it with React Router.
 * @returns {function(*=): React$ComponentType<*>}
 */
export default () => BaseComponent => {
  type Props = {
    store: any,
    originalProps: any
  };

  class FeatureRoute extends Component<Props> {
    constructor(props) {
      super(props);

      if (!props.store) {
        // Throw an error if the store is not available to us
        throw new Error(
          'This component can only be used on a Container component!'
        );
      }

      this.enabled = false;
    }

    componentWillMount() {
      this.enabled = checkEnabled(this.props.originalProps, this.props.store);
    }

    render() {
      if (!this.enabled && __SERVER__) {
        return <NotFound />;
      }

      return <BaseComponent {...this.props.originalProps} />;
    }
  }

  const displayName =
    BaseComponent.displayName || BaseComponent.name || 'Component';

  FeatureRoute.displayName = `FeatureRoute[${displayName}]`;

  safelyHoistStatics(FeatureRoute, BaseComponent);

  const WithStore = props => {
    const store = useContext(ReactReduxContext);

    return React.createElement(FeatureRoute, {
      originalProps: props,
      ...store
    });
  };

  return withRouter(WithStore);
};
